<div class="modal-header">
  <h5 class="modal-title">{{ vendor.id ? 'Chỉnh sửa' : 'Thêm' }} Nhà cung cấp</h5>
  <button type="button" class="close" aria-label="Đóng" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form (ngSubmit)="onSaveClick()" #vendorForm="ngForm">
    <div class="form-group">
      <label for="name">
        Tên
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập tên của nhà cung cấp.<br><b>Ví dụ:</b> Công ty ACME"></i>
      </label>
      <input type="text" class="form-control" id="name" [(ngModel)]="vendor.name" name="name" placeholder="ví dụ: Công ty ACME" required>
    </div>
    <div class="form-group">
      <label for="address">
        Địa chỉ
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập địa chỉ của nhà cung cấp.<br><b>Ví dụ:</b> 123 Đường Chính, Thành phố, Quốc gia"></i>
      </label>
      <input type="text" class="form-control" id="address" [(ngModel)]="vendor.address" name="address" placeholder="ví dụ: 123 Đường Chính, Thành phố, Quốc gia" required>
    </div>
    <div class="form-group">
      <label for="phone">
        Điện thoại
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập số điện thoại liên hệ của nhà cung cấp.<br><b>Ví dụ:</b> (123) 456-7890"></i>
      </label>
      <input type="text" class="form-control" id="phone" [(ngModel)]="vendor.phone" name="phone" placeholder="ví dụ: (123) 456-7890" required>
    </div>
    <div class="form-group">
      <label for="fax">
        Fax
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập số fax của nhà cung cấp.<br><b>Ví dụ:</b> (123) 456-7891"></i>
      </label>
      <input type="text" class="form-control" id="fax" [(ngModel)]="vendor.fax" name="fax" placeholder="ví dụ: (123) 456-7891">
    </div>
    <div class="form-group">
      <label for="website">
        Trang web
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập trang web của nhà cung cấp.<br><b>Ví dụ:</b> www.acme-corp.com"></i>
      </label>
      <input type="text" class="form-control" id="website" [(ngModel)]="vendor.website" name="website" placeholder="ví dụ: www.acme-corp.com">
    </div>
    <div class="form-group">
      <label for="accountNumber">
        Số tài khoản
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập số tài khoản của nhà cung cấp.<br><b>Ví dụ:</b> 123456789"></i>
      </label>
      <input type="text" class="form-control" id="accountNumber" [(ngModel)]="vendor.accountNumber" name="accountNumber" placeholder="ví dụ: 123456789" required>
    </div>
    <div class="form-group">
      <label for="position">
        Chức vụ
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập chức vụ hoặc tiêu đề của nhà cung cấp.<br><b>Ví dụ:</b> Quản lý bán hàng"></i>
      </label>
      <input type="text" class="form-control" id="position" [(ngModel)]="vendor.position" name="position" placeholder="ví dụ: Quản lý bán hàng">
    </div>
    <div class="form-group">
      <label for="alternativePhone">
        Điện thoại thay thế
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập số điện thoại thay thế.<br><b>Ví dụ:</b> (987) 654-3210"></i>
      </label>
      <input type="text" class="form-control" id="alternativePhone" [(ngModel)]="vendor.alternativePhone" name="alternativePhone" placeholder="ví dụ: (987) 654-3210">
    </div>
    <div class="form-group">
      <label for="email">
        Email
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập địa chỉ email của nhà cung cấp.<br><b>Ví dụ:</b> contact@acme-corp.com"></i>
      </label>
      <input type="email" class="form-control" id="email" [(ngModel)]="vendor.email" name="email" placeholder="ví dụ: contact@acme-corp.com" required>
    </div>
    <div class="form-group">
      <label for="notes">
        Ghi chú
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập thông tin bổ sung hoặc ghi chú về nhà cung cấp.<br><b>Ví dụ:</b> Phương thức giao hàng ưu tiên"></i>
      </label>
      <textarea class="form-control" id="notes" [(ngModel)]="vendor.notes" name="notes" placeholder="ví dụ: Phương thức giao hàng ưu tiên"></textarea>
    </div>
    <div class="form-group">
      <label for="taxNumberRegistered">
        Đã đăng ký mã số thuế
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Chỉ định nếu nhà cung cấp đã đăng ký mã số thuế.<br><b>Ví dụ:</b> Có hoặc Không"></i>
      </label>
      <input type="checkbox" id="taxNumberRegistered" [(ngModel)]="vendor.taxNumberRegistered" name="taxNumberRegistered">
    </div>
    <div class="form-group">
      <label for="invoicePricesIncludeTax">
        Giá hóa đơn bao gồm thuế
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Chỉ định nếu giá hóa đơn bao gồm thuế.<br><b>Ví dụ:</b> Có hoặc Không"></i>
      </label>
      <input type="checkbox" id="invoicePricesIncludeTax" [(ngModel)]="vendor.invoicePricesIncludeTax" name="invoicePricesIncludeTax">
    </div>
    <div class="form-group">
      <label for="taxRate">
        Thuế suất
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập thuế suất áp dụng cho nhà cung cấp.<br><b>Ví dụ:</b> 20.00"></i>
      </label>
      <input type="number" class="form-control" id="taxRate" [(ngModel)]="vendor.taxRate" name="taxRate" placeholder="ví dụ: 20.00" step="0.01">
    </div>
    <div class="form-group">
      <label for="discount">
        Giảm giá
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập bất kỳ giảm giá nào được cung cấp bởi nhà cung cấp.<br><b>Ví dụ:</b> 10.00"></i>
      </label>
      <input type="number" class="form-control" id="discount" [(ngModel)]="vendor.discount" name="discount" placeholder="ví dụ: 10.00" step="0.01">
    </div>
    <div class="form-group">
      <label for="deliveryTime">
        Thời gian giao hàng
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập thời gian giao hàng dự kiến.<br><b>Ví dụ:</b> 3-5 ngày làm việc"></i>
      </label>
      <input type="text" class="form-control" id="deliveryTime" [(ngModel)]="vendor.deliveryTime" name="deliveryTime" placeholder="ví dụ: 3-5 ngày làm việc">
    </div>
    <div class="form-group">
      <label for="additionalNotes">
        Ghi chú bổ sung
        <i class="fas fa-info-circle" title="<b>Mô tả:</b> Nhập bất kỳ thông tin bổ sung hoặc ghi chú nào về nhà cung cấp.<br><b>Ví dụ:</b> Phương thức giao hàng ưu tiên"></i>
      </label>
      <textarea class="form-control" id="additionalNotes" [(ngModel)]="vendor.additionalNotes" name="additionalNotes" placeholder="ví dụ: Phương thức giao hàng ưu tiên"></textarea>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Hủy</button>
      <button type="submit" class="btn btn-outline-primary">Lưu</button>
    </div>
  </form>
</div>
